import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { put } = request;
const { Authorization, Bearer } = AUTHORIZATION;

export type dateofBirthUpdatePayloadType = {
	group_number: number;
	role: string;
	SSN: string;
	date_of_birth: string;
};

const initialRoute = "auth";

export const dateofBirth = async (dateofBirthUpdatePayload: dateofBirthUpdatePayloadType) => {
	try {
		const payload = JSON.stringify(dateofBirthUpdatePayload);
		const endpoint = `${initialRoute}/dob-update`;
		const token = localStorage.getItem("@jwt");
		const response = await put(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.put.succ) {
				// const {
				// 	data: { result }
				// } = response;
				return message;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
